/**
 * .Farra — Gallery lightbox
 *
 * Click any image inside [data-farra-variant-gallery] to open a full-
 * screen overlay showing that image large. Keyboard: Escape closes,
 * ArrowLeft/ArrowRight cycle through the currently-visible chapter's
 * images. Click outside the image or the ✕ button to close.
 *
 * Uses the same image src at a larger requested width so quality holds
 * up on zoom. Requires Shopify's CDN image URL pattern (?width=...).
 */
(function () {
  let overlay, imgEl, closeBtn, prevBtn, nextBtn;
  let currentImages = [];
  let currentIndex = 0;

  function buildOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'farra-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = `
      <button class="farra-lightbox__close" aria-label="Close">✕</button>
      <button class="farra-lightbox__nav farra-lightbox__nav--prev" aria-label="Previous image">‹</button>
      <img class="farra-lightbox__img" alt="">
      <button class="farra-lightbox__nav farra-lightbox__nav--next" aria-label="Next image">›</button>
    `;
    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.farra-lightbox__img');
    closeBtn = overlay.querySelector('.farra-lightbox__close');
    prevBtn = overlay.querySelector('.farra-lightbox__nav--prev');
    nextBtn = overlay.querySelector('.farra-lightbox__nav--next');

    // Click outside the image closes; clicks on the image itself do not
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === closeBtn) close();
    });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); showIndex(currentIndex - 1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); showIndex(currentIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') showIndex(currentIndex - 1);
      if (e.key === 'ArrowRight') showIndex(currentIndex + 1);
    });
  }

  function upgradeSrc(src) {
    // Bump width param on Shopify CDN URLs so the zoom is sharp
    try {
      const url = new URL(src, window.location.origin);
      if (url.searchParams.has('width')) url.searchParams.set('width', '2400');
      return url.toString();
    } catch (_) {
      return src;
    }
  }

  function showIndex(i) {
    if (!currentImages.length) return;
    if (i < 0) i = currentImages.length - 1;
    if (i >= currentImages.length) i = 0;
    currentIndex = i;
    const src = currentImages[i];
    imgEl.src = upgradeSrc(src.src);
    imgEl.alt = src.alt || '';
    // Hide nav buttons if only one image
    prevBtn.hidden = currentImages.length < 2;
    nextBtn.hidden = currentImages.length < 2;
  }

  function open(images, startIndex) {
    buildOverlay();
    currentImages = images;
    showIndex(startIndex || 0);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('farra-lightbox-open');
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('farra-lightbox-open');
  }

  function currentVisiblePane() {
    const wrapper = document.querySelector('[data-farra-variant-gallery]');
    if (!wrapper) return null;
    return wrapper.querySelector('[data-farra-gallery-chapter]:not([hidden])');
  }

  document.addEventListener('click', function (e) {
    const item = e.target.closest('.farra-variant-gallery__item');
    if (!item) return;
    e.preventDefault();
    const pane = currentVisiblePane();
    if (!pane) return;
    const allItems = Array.from(pane.querySelectorAll('.farra-variant-gallery__item'));
    const images = allItems.map(function (el) {
      const im = el.querySelector('img');
      return im ? { src: im.currentSrc || im.src, alt: im.alt } : null;
    }).filter(Boolean);
    const startIndex = allItems.indexOf(item);
    open(images, startIndex);
  });
})();
